import { render, staticRenderFns } from "./ContractDamageComponent.vue?vue&type=template&id=8a1e5570&scoped=true&"
import script from "./ContractDamageComponent.vue?vue&type=script&lang=js&"
export * from "./ContractDamageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1e5570",
  null
  
)

export default component.exports